import { forwardRef } from 'react';
import type { LucideIcon, LucideProps } from 'lucide-react';

interface IconProps extends Omit<LucideProps, 'ref'> {
  icon: LucideIcon;
}

export const Icon = forwardRef<SVGSVGElement, IconProps>(function Icon(
  { icon: I, size = 20, strokeWidth = 1.75, ...rest },
  ref,
) {
  return <I ref={ref} size={size} strokeWidth={strokeWidth} aria-hidden="true" {...rest} />;
});
